var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTopRightOnSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4738 1.74512L10.2088 1.74512C9.79462 1.74512 9.45883 2.0809 9.45883 2.49512C9.45883 2.90933 9.79462 3.24512 10.2088 3.24512L11.637 3.24512L10.037 4.81305C9.80822 4.72189 9.5586 4.67177 9.29728 4.67177L3.96875 4.67177C2.86418 4.67177 1.96875 5.5672 1.96875 6.67177L1.96875 12.0003C1.96875 13.1049 2.86418 14.0003 3.96875 14.0003L9.29728 14.0003C10.4018 14.0003 11.2973 13.1049 11.2973 12.0003V6.67177C11.2973 6.37909 11.2344 6.1011 11.1214 5.85056L12.7238 4.28022L12.7238 5.7601C12.7238 6.17431 13.0596 6.5101 13.4738 6.5101C13.888 6.5101 14.2238 6.17431 14.2238 5.7601L14.2238 2.49512C14.2238 2.2962 14.1448 2.10544 14.0041 1.96479C13.8635 1.82413 13.6727 1.74512 13.4738 1.74512ZM11.1214 5.85056C10.9089 5.37925 10.5191 5.00508 10.037 4.81305L5.1751 9.57775C4.87926 9.86767 4.87447 10.3425 5.16439 10.6384C5.45431 10.9342 5.92916 10.939 6.22499 10.6491L11.1214 5.85056Z",
    fill: "#677B99"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTopRightOnSquare);
export default __webpack_public_path__ + "static/media/arrow-top-right-on-square.a7330e5e9df5d3074eee7e15f71675fb.svg";
export { ForwardRef as ReactComponent };